// Utility functions for managing risk disclaimer localStorage

const RISK_DISCLAIMER_KEY = 'analyzerview_risk_disclaimer_accepted'

export const hasAcceptedRiskDisclaimer = (): boolean => {
  try {
    const accepted = localStorage.getItem(RISK_DISCLAIMER_KEY)
    return accepted === 'true'
  } catch (error) {
    // In case localStorage is not available (e.g., incognito mode)
    console.warn('localStorage not available:', error)
    return false
  }
}

export const setRiskDisclaimerAccepted = (accepted: boolean): void => {
  try {
    localStorage.setItem(RISK_DISCLAIMER_KEY, accepted.toString())
  } catch (error) {
    console.warn('Failed to save risk disclaimer status:', error)
  }
}

export const clearRiskDisclaimerStatus = (): void => {
  try {
    localStorage.removeItem(RISK_DISCLAIMER_KEY)
  } catch (error) {
    console.warn('Failed to clear risk disclaimer status:', error)
  }
}